export default __webpack_public_path__ + "static/studycafe-office4-36668e82c4e9202531c1b8c566b0b0db.jpg";